import { SidebarTrigger } from '@/components/ui/sidebar';

export default function TeamHeader() {
  return (
    <header className="border-b">
      <div className="flex h-12 items-center gap-4 px-6">
        <SidebarTrigger className="cursor-pointer" />
      </div>
    </header>
  );
}
